import { boxStats } from "@/lib/science/plot-stats";
import { SCI_PALETTE } from "@/lib/science/sci-chart";
import { cartesianAxis, PlotShell } from "@/lib/science/sci-plot";
import { m } from "@/paraglide/messages";

const EXAMPLE =
  "Group A,Group B,Group C\n5,8,3\n6,9,4\n7,7,5\n5,10,4\n8,9,6\n6,8,3\n7,11,5\n4,7,4";

export function BoxPlot() {
  return (
    <PlotShell
      toolId="box-plot"
      inputLabel={m.plot_input_label()}
      placeholder={m.box_placeholder()}
      example={EXAMPLE}
      exampleLabel={m.plot_load_example()}
      hint={m.plot_hint_empty()}
      buildOption={(data, theme) => {
        const boxes = data.colHeaders.map((_, ci) => {
          const col = data.matrix
            .map((row) => row[ci])
            .filter((n) => Number.isFinite(n));
          const s = boxStats(col);
          return s ? [s.min, s.q1, s.median, s.q3, s.max] : [0, 0, 0, 0, 0];
        });
        return {
          tooltip: { trigger: "item" },
          grid: { left: 48, right: 20, top: 20, bottom: 30 },
          xAxis: {
            type: "category",
            data: data.colHeaders,
            ...cartesianAxis(theme),
          },
          yAxis: { type: "value", ...cartesianAxis(theme) },
          series: [
            {
              type: "boxplot",
              data: boxes,
              itemStyle: {
                color: SCI_PALETTE[2],
                borderColor: SCI_PALETTE[0],
                borderWidth: 2,
              },
            },
          ],
        };
      }}
    />
  );
}
